/**
 * Converte uma string para PascalCase.
 * Exemplos:
 *   "hello world" -> "HelloWorld"
 *   "  usuário-teste " -> "UsuarioTeste"
 */
export function toPascalCase(input: string): string {
    if (!input) return '';

    return input
        .trim()
        // Remove diacríticos (acentos)
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        // Substitui qualquer sequência não alfanumérica por espaço
        .replace(/[^0-9a-zA-Z]+/g, ' ')
        .split(/\s+/)
        .filter(Boolean)
        .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        .join('');
}